/**
 * 工程基础配置
 */
import { LanguageCode, CountryCode } from "@al/base-lib";

import { IKI_SLIDER_REPORT_URL } from "../constant";
import AppType from "../enums/AppType";
import { defaultCountryCodeConfig } from "../dict/base";

import getAppName from "./getAppName";

// 获取默认的国家码
export function getDefaultCountryCode(ctx?: any): CountryCode {
  const _webSite = getAppName(ctx);
  return defaultCountryCodeConfig[_webSite];
}

// app外设置默认语言才有效
export function getDefaultLanguageCode(ctx?: any): LanguageCode {
  const req = ctx.req;
  if (req && req.headers && req.headers["accept-language"]) {
    const acceptLanguage = req.headers["accept-language"];
    const langs = acceptLanguage.split(",");
    for (let i = 0; i < langs.length; i++) {
      const [langType] = langs[i].split(";");
      // 暂时不区分不同国家同种语言的语言类型，比如en-us也只用en作为语言
      const [langCode] = langType.split("-");
      // FIXME 这里浏览器的语言 code 是 id, 特殊处理一下。
      if (langCode === "id") return "in" as LanguageCode;
      // 过滤掉中文，暂时c端没有中文的使用场景
      if (langCode in LanguageCode && langCode !== "zh") {
        return langCode;
      }
    }
  }
  const _webSite = getAppName(ctx);
  return {
    [AppType.Akulaku]: LanguageCode.in, // 印尼
    [AppType.Silvrrplus]: LanguageCode.ms, // 印尼
    [AppType.Silvrr]: LanguageCode.en, // 欧洲外部浏览器默认语言为英语
  }[_webSite];
}

export function getIkiSliderReportUrl(env: string): string {
  if (env === "prod" || env === "pre") {
    return `https://${IKI_SLIDER_REPORT_URL}`;
  }

  return `https://test-${IKI_SLIDER_REPORT_URL}`;
}
